const MAIL = 'customersuccess@prospectiq.ai';

export const LeadsUnavailable = () => {
  return (
    <div className="flex justify-center items-center flex-col rounded-[20px] bg-white/65 min-h-[574px] flex-1 p-16">
      <span className="text-base-1000 font-semibold text-[22px]/[28px] text-center">
        You have no leads available to call during this hour
      </span>
      <span className="text-base-800 font-normal text-[16px]/[24px] text-center">
        Check back later, update your ICP or feel free to send a message to
      </span>
      <a href={`mailto:${MAIL}`}>
        <span className="text-secondary font-medium text-[16px]/[24px] text-center">
          {MAIL}
        </span>
      </a>
    </div>
  );
};
